(function () {
    'use strict';

    angular
        .module('cog.shared.maintenance')
        .controller('ApiMaintenanceController', ApiMaintenanceController);

    /* @ngInject */
    function ApiMaintenanceController(notificationService:INotificationService, versionContainer, $timeout, $window) {
        var vm = this;
        vm.loader = false;
        vm.reload = reload;
        activate();

        function activate() {
            // need service to check to see if API is up
            notificationService.notify_logout();
            //$timeout(callAtTimeout, 10000);            
        }
        
        function reload() {
            $window.location.assign("/");
        }

        function callAtTimeout() {
            versionContainer.checkVersion().then(function (data) {    
                 $window.location.assign("/");
            })
            .catch(function (data) {
                 $timeout(callAtTimeout, 10000);                            
            }).finally(function () {
                   
            });
        }
    }
})();
